import { render, staticRenderFns } from "./SkinChipLinkWorkshop.vue?vue&type=template&id=51d0ca52&scoped=true&"
import script from "./SkinChipLinkWorkshop.vue?vue&type=script&lang=ts&"
export * from "./SkinChipLinkWorkshop.vue?vue&type=script&lang=ts&"
import style0 from "./SkinChipLinkWorkshop.vue?vue&type=style&index=0&id=51d0ca52&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d0ca52",
  null
  
)

export default component.exports